module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("精选电台")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })]), _vm._v(" "), _c('section', {
    staticClass: "type"
  }, [_c('span', {
    staticClass: "first"
  }, [_c('img', {
    attrs: {
      "src": "https://p.qpic.cn/music_cover/KWul6PEBRTRXtxIIqGZBSdyWapkicmbusJPHZcrIfhqfiacbTnEGfltw/300?n=1",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("90后")])]), _vm._v(" "), _c('span', {
    staticClass: "middle"
  }, [_c('img', {
    attrs: {
      "src": "https://p.qpic.cn/music_cover/8HhavvWNIicpyjlv0UnT5TTPic7kJoZ4IqytNr1WVqoJNgTtE6kry79w/300?n=1",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("古风")])]), _vm._v(" "), _c('span', [_c('img', {
    attrs: {
      "src": "https://p.qpic.cn/music_cover/eO1iarCrMC5jNLJicQibtNolrqRaiafSMJMRTPmZiaTibX5Bgcp3yPSDS70Q/300?n=1",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("民俗")])])]), _vm._v(" "), _c('div', {
    staticClass: "showBox"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000000h2IRx0Ap45C.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("唱反调 | 吃火锅底料的GAI爷")]), _vm._v(" "), _c('p', [_vm._v("主播：DJ周杨")]), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("1.3万")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000004ULoqM4HpMKF.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("回到过去 | 磁带里走出的夏天")]), _vm._v(" "), _c('p', [_vm._v("主播：任志红")]), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("1.1万")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000002xaPnq0BXNav.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("幽暗恢宏迷离消逝-英国才华横溢...")]), _vm._v(" "), _c('p', [_vm._v("主播：Konekt Asia")]), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("1.3万")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000003fMl4c3ItNV4.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("九张机(Cover叶炫清)")]), _vm._v(" "), _c('p', [_vm._v("主播：ayo又")]), _vm._v(" "), _c('i'), _vm._v(" "), _c('span', [_vm._v("1.5万")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb533ce6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xchosen.vue
// module id = 281
// module chunks = 0